import { gql } from '@apollo/client';

const USER_ALL_TOURNAMENTS = gql`
  query userAllTournaments($userId: Int, $page: Int, $limit: Int, $filter: ListTournamentInput, $platform: Float, $isUpcomingAndProgress: Boolean) {
    userAllTournaments(userId: $userId, page: $page, limit: $limit, filter: $filter, platform: $platform, isUpcomingAndProgress: $isUpcomingAndProgress)
  }
`;

export default USER_ALL_TOURNAMENTS;
